/**
 *
 * AssignModal
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ListGroup, Modal } from 'react-bootstrap';
import LimitHeight from 'components/layout/LimitHeight/index.js';
import { shortTimeString } from 'utils/eventTimes.js';
import MeetingItem from './MeetingItem.jsx';
import messages from './messages.js';

function AssignModal(props) {
  const { onHide, slot, meetingList, onChange, show } = props;
  const time = slot && shortTimeString(slot);
  if (!meetingList) {
    return null;
  }
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton className="mb-0">
        <Modal.Title>
          <FormattedMessage {...messages.header} values={{ time }} />
        </Modal.Title>
      </Modal.Header>
      <LimitHeight as={ListGroup} variant="flush" className="mb-3" margin="180px">
        {meetingList.map((meeting) => (
          <MeetingItem key={meeting.id} meeting={meeting} onClick={() => onChange(meeting.id)} />
        ))}
      </LimitHeight>
    </Modal>
  );
}

AssignModal.propTypes = {
  onHide: PropTypes.func,
  show: PropTypes.bool,
  slot: PropTypes.object,
  meetingList: PropTypes.array,
  onChange: PropTypes.func,
};

export default AssignModal;
